<template>
  <div class="client-selection">
    <div class="client-name" v-if="clients.length == 1">{{ clients[0].name }}</div>
    <div class="client-dropdown" :class="{active: isVisible}" v-if="clients.length > 1">
      <button
        class="client-dropdown-btn"
        :class="{active: isVisible}"
        @click="isVisible = !isVisible"
      >
        Select Clients
        <font-awesome-icon icon="angle-down" size="lg" fixed-width class="icon closed"/>
        <font-awesome-icon icon="angle-up" size="lg" fixed-width class="icon open"/>
      </button>
      <div class="client-list" v-if="isVisible">
        <b-form-group>
          <!-- disables the checkbox for selected client if only one client is selected -->
          <b-form-checkbox
            v-for="(client,index) in clients"
            v-model="selection"
            :key="'a_' + index"
            :value="client"
            name="clients"
            :disabled="shouldToggleBeDisabled(client)"
            @change="changeClient($event, client, index)"
          >
            <div class="row">
              <div class="col">{{ client.name }}</div>
            </div>
            <div class="row text-secondary tinyfont">
              <div class="col">{{client.id}}</div>
            </div>
          </b-form-checkbox>
        </b-form-group>
      </div>
    </div>
    <div class="selected-client-list" v-if="clients.length > 1">
      <h4>{{ selection.length }} {{ selection.length > 1 ? 'Clients' : 'Client' }} Selected</h4>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";

.client-selection {
  padding: 20px;
  background: rgba(255, 255, 255, 0.1);
  .client-name {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.8);
  }
  .client-dropdown {
    position: relative;
    z-index: 500;
    .client-dropdown-btn {
      width: 100%;
      background: none;
      border-radius: 3px;
      border: 2px solid rgba(255, 255, 255, 0.2);
      color: #fff;
      text-align: left;
      padding: 0 10px;
      height: 40px;
      transition: all 200ms;
      .icon {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        &.open {
          display: none;
        }
      }
      &:hover {
        border-color: rgba(255, 255, 255, 0.4);
        background: rgba(255, 255, 255, 0.05);
      }
      &.active {
        .icon {
          &.open {
            display: block;
          }
          &.closed {
            display: none;
          }
        }
      }
    }
    .client-list {
      position: absolute;
      padding: 10px;
      background: #fff;
      border-radius: 0px 0px 3px 3px;
      width: 100%;
      transition: all 200ms;
      .form-group {
        margin: 0px;
      }
    }
    &.active {
      background: #fff;
      border-radius: 3px 3px 0px 0px;
      .client-dropdown-btn {
        border-color: transparent;
        color: $text-color-normal;
      }
    }
  }
  .selected-client-list {
    padding: 20px 0px 0px;
    color: #fff;
    transition: all 200ms;
    h4 {
      font-size: 0.8rem;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.4);
      font-weight: $font-weight-normal;
      margin: 0px;
    }
    li {
      display: inline-block;
      color: #fff;
      font-size: 0.8rem;
      &::after {
        content: ",";
      }
    }
  }
}

.tinyfont {
  font-size: x-small;
}

.lightgreentext {
  color: #d8d622;
}
</style>

<script>
export default {
  name: "ClientSelection",
  components: {},
  props: {
    selectedClients: {
      type: Array,
      default: () => []
    },
    clients: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selection: [],
      isVisible: false
    };
  },
  watch: {
    selectedClients: function() {
      // clone the array! - very important
      this.selection = this.selectedClients.slice();
    }
  },
  methods: {
    changeClient(event, client) {
      if (event) {
        // add the client
        this.selection.push(client);
      } else {
        // delete the client - find it and remove from list
        for (let i = this.selection.length - 1; i >= 0; i--) {
          const c = this.selection[i];
          if (c.id === client.id) {
            this.selection.splice(i, 1);
          }
        }
      }
      this.$emit("cschange", this.selection);
    },
    // Remove client from selection
    removeClient(index) {
      this.$delete(this.selection, index);
      this.$emit("cschange", this.selection);
    },
    shouldToggleBeDisabled(client) {
      // does selectedClients only contain one item?
      if (this.selection.length === 1) {
        // does it contain this entry?
        for (let i = 0; i < this.selection.length; i++) {
          // match, so return true and disable the checkbox
          if (this.selection[i].id === client.id) {
            return true;
          }
        }
        // no match, so enable checkbox
        return false;
      }
      // more than one selected, so enable checkbox
      return false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ClientSelection.vue